module.exports = __webpack_public_path__ + "img/img_size5_hc.bb9b2818.png";